import { render, staticRenderFns } from "./AboutUs_FR.vue?vue&type=template&id=76867b90&scoped=true&"
import script from "./AboutUs_FR.vue?vue&type=script&lang=js&"
export * from "./AboutUs_FR.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_FR.vue?vue&type=style&index=0&id=76867b90&prod&lang=css&"
import style1 from "./AboutUs_FR.vue?vue&type=style&index=1&id=76867b90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76867b90",
  null
  
)

export default component.exports